import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

import { TOption } from 'src/constants/types'

type TInfoData = {
  specs: TOption[],
  regions: TOption[]
}

const downloadXLSX = async (dataToRender: any, infoData: TInfoData) => {
  const preparedData = Object.keys(dataToRender).filter((key) => key !== 'summarizedData').reduce((acc: string[][], key) => {
    const { total, allowPartnersEmails, allowContactsByPhone, regions } = (dataToRender as any)[key]
    const specName = infoData.specs.find((el: any) => el.value === Number(key))?.label || ''

    acc.push([specName, total, allowPartnersEmails, allowContactsByPhone])
    if (Object.keys(regions)?.length) {
      Object.keys(regions).map((regionId) => {
        const { total, allowPartnersEmails, allowContactsByPhone } = regions[regionId]
        const regionName = infoData.regions.find((el: any) => el.value === Number(regionId))?.label || ''
        acc.push([regionName, total, allowPartnersEmails, allowContactsByPhone])
      })
    }
    return acc
  }, [])

  preparedData.unshift(['', 'Всего юзеров', 'Разрешены рекламные рассылки', 'Разрешены мессенджеры'])

  if (dataToRender?.summarizedData) preparedData.push(['ИТОГО', dataToRender?.summarizedData.total, dataToRender?.summarizedData.allowPartnersEmails, dataToRender?.summarizedData.allowContactsByPhone])

  const ws = XLSX.utils.aoa_to_sheet(preparedData)

  ws['!cols'] = [{ wch: 50 }, { wch: 20 }, { wch: 20 }, { wch: 20 }]

  const workbook = {
    SheetNames: ['Sheet1'],
    Sheets: { Sheet1: ws }
  }

  saveAs(
    new Blob([XLSX.write(workbook, { bookType: 'xlsx', bookSST: false, type: 'array' })], {
      type: 'application/octet-stream'
    }),
    `total.xlsx`
  )

}

export default downloadXLSX